import { knock, setup as setupLogging } from '@nutrien/ddc-fe-logging-pwa';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Root } from './components/Root/Root';
import { configuration } from './logging/configuration';
import { identifiers } from './logging/identifiers';
import { registerServiceWorker } from './registerServiceWorker';

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

async function startup() {
  const logging = await setupLogging(configuration, identifiers);
  registerServiceWorker(logging);
  knock(logging);

  root.render(
    <StrictMode>
      <Root logging={logging} />
    </StrictMode>,
  );
}

startup().catch(error => {
  // A fatal error has occurred, quite possibly in the logging system itself.
  // eslint-disable-next-line no-console
  console.error(error);
  root.render(<h1>Critical Error During Application Startup</h1>);
});
